module.exports = __webpack_public_path__ + "img/speed.bf4848a7.svg";